import { Button, Menu } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useAuthState } from '../../hooks/auth';
import { authService, Translate } from '../../services';
import { AvatarIcon, Divider, Link } from '../common';
import { ACTIVE_BRAND_CONFIG } from '../../branding/const';
import { LanguageSelectorLink } from '../languageSelector/LanguageSelector';
import './styles.less';
import { useUserDetailsQuery } from '../../gql/hooks';
import { Routes } from '../../navigation';

const ProfileDropdown = ( { closeDropdown, setLoggingOut, loggingOut } ) => {
    
    const { claims } = useAuthState();

    const { client } = useUserDetailsQuery();
    
    const logOut = async () => {
        client.resetStore();
        await authService.signOut();
    };

    return (
        <Menu>
            <Menu.Item key='username'>
                <AvatarIcon
                    username={ claims.name } />
                    <span className={ classNames( 'primary', 'username' ) }>{ [ claims.given_name, claims.family_name?.substring( 0, 1 ) ].join( ' ' ) }</span>
            </Menu.Item>
            <Menu.Item key='my-account'>
            <Button className={ classNames( 'secondary' ) }
                    onClick={ () => {
                            if ( ACTIVE_BRAND_CONFIG.myAccountURL ) { 
                                window.location.href = ACTIVE_BRAND_CONFIG.myAccountURL;
                            }
                        }
                    }
                >
                    <Translate.Text value="header.nav.myAccount" />
                </Button>
            </Menu.Item>
            <Menu.Item>
                <Link linkClass="ant-btn secondary" push to={ Routes.LearningTranscript.buildPath() }>
                    <Translate.Text value="transcript.learning.transcript" />
                </Link>
            </Menu.Item>
            <Menu.Item className='divider' key='div1'><Divider/></Menu.Item>
            <Menu.Item className='menu-item-language' key='language'>
                <LanguageSelectorLink onClick={ () =>  closeDropdown() } />
            </Menu.Item>
            <Menu.Item className='divider' key='div2'><Divider/></Menu.Item>
            <Menu.Item key='logout' className='logout'>
                <Button className={ classNames( 'primary' ) }
                    onClick={ () => { setLoggingOut( true ); logOut(); } }
                    loading={ loggingOut }>
                    { !loggingOut && <Translate.Text value="header.profile.logOut" /> }
                </Button>
            </Menu.Item>
        </Menu>
    );
};

export default ProfileDropdown;